import React from 'react';
import styled from 'styled-components';
import * as colors from '../../util/colors';
import logo from '../../assets/keytruda-logo-light.svg';
import * as CTA from '../../util/CTA';
import Link from 'gatsby-link';
import FooterMenu from './FooterMenu';
import qsubKeytruda from '../../assets/keytruda-qlex-logo.svg';
import keytrudaDark from '../../assets/keytruda-logo.svg';

const MOBILE_BREAKPOINT= 420;

const items = [
    {
        label: 'Efficacy Information',
        children: [
            {
                label: 'Efficacy',
                url: '/efficacy/',
            },
        ],
    },
    {
        label: 'Safety',
        children: [
            {
                label: 'Selected Adverse Reactions',
                url: '/safety/adverse-reactions/',
            },
            {
                label: 'Treatment Monitoring & Management',
                url: '/safety/monitoring-managing-adverse-reactions/',
            },
        ],
    },
    {
        label: 'Biomarker Testing',
        children: [
            {
                label: 'Biomarker Overview',
                url: '/biomarker-testing/biomarker-overview/',
            },
            {
                label: 'PD-L1 Testing & Scoring',
                url: '/biomarker-testing/pd-l1/',
            },
            {
                label: 'MSI/MMR Testing',
                url: '/biomarker-testing/msi-mmr/',
            },
        ],
    },
    {
        label: 'Dosing & Preparation',
        children: [
            {
                label: 'Dosing',
                url: '/dosing/options/',
            },
            {
                label: 'Preparation, Storage & Administration',
                url: '/dosing/preparation-storage-administration/',
            },
            {
                label: 'Dose Modifications',
                url: '/dosing/dose-modifications/',
            },
        ],
    },
    {
        label: "Resources",
        children: [
            {
                label: 'Resource Center',
                url: '/resources/hcp-and-patient-resources/',
            },
            {
                label: 'Patient Support Program',
                url: '/resources/key-you-patient-support-program/',
            },
            {
                label: 'Mechanism of Action',
                url: '/resources/mechanism-of-action/',
            },
            /*{
                label: 'Surgeon Resource Center',
                url: '/resources/surgeon-resources/',
            }*/
        ]
    }
];

export const FooterContainer = styled.div`
    max-width: 100%;
    background: ${colors.charcoal};
    padding-top: 20px;

    ${({brandType}) => brandType === 'qsub' && `
        background: ${colors.cloud};
    `}

   
`;

const FooterNavigationContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    box-sizing: content-box;
    max-width: 992px;
    margin: 0 auto;
    padding: 20px 20px 0;

    > div {
        &:first-child {
            min-width: 233px;
            display: flex;
            flex: 1 1 135px;
            margin: 0;
        }
        &:last-child {
            flex: 2 1 473px;
            display: flex;
            justify-content: space-between;
        }
    }

    ${({brandType}) => brandType === 'qsub' && `
    @media (min-width: 767px){
        padding: 0 20px;
    }
    `}
`;

const LogoContainer = styled.div`
    display: flex;
    justify-content: center;
    height: 100%;
    min-height: 120px;

    img {
        width: 160px;
        height: 50.966px;
        padding-bottom: 0.725em;
    }
    
    ${({brandType}) => brandType === 'qsub' && `
    width: 100%;
    flex-direction: column;
      @media (min-width: 767px){
        justify-content: space-between;
        flex-direction: row;
      }
     @media (max-width: 767px){
        > div:nth-child(2){
        margin: 12px 0;
     }     
    }
    `};
`;

const QSubLogoContainer = styled.div`
img {
    // height: 50.966px;
    margin:0;
    padding:0;
    margin-right: 16px;
    width:120px;
    height:38px;
    vertical-align: top;
}
.qsub-img {
    height: 50.966px;
    width: 229.275px;
    padding-left:16px;
    border-left: 0.6px solid ${colors.silver};
    }
@media (min-width: 767px){
    margin-top: 25px;
}

@media (max-width: 478px) {
    display: flex;
    align-items: center;
img {
    width: 74.4px;
    height: 23.5px;
    margin-bottom:7.5px;
    }
    .qsub-img {
        width: 142.62px;
        height: 31.693px;
        margin:0;
        margin: 7.5px 0;
    }
}
`;

export const FooterNavigation = (props) => {
    return (
        <>
                <FooterNavigationContainer brandType={props.brandType}>
                    <div>
                        <LogoContainer brandType={props.brandType}>
                            {props.brandType === 'qsub' && <QSubLogoContainer>
                               <Link to="/"><img src={keytrudaDark} alt="KEYTRUDA® (pembrolizumab): Website for Health Care Professionals" /></Link>
                                <Link to="/qlex/"><img src={qsubKeytruda} alt='KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph) Logo' className='qsub-img'/></Link>
                            </QSubLogoContainer>}
                            <div>
                               {props.brandType !== 'qsub' && <Link title="Home" to="/" data-design-category='bottom_nav_vd'>
                                    <img src={logo} alt="KEYTRUDA® (pembrolizumab): Website for Health Care Professionals" />
                                </Link> }                                                                                 
                                <div>
                                    <CTA.TertiaryButton
                                        dataDesignCategory="bottom_nav_vd"
                                        theme={props.brandType !== 'qsub' ? "light" : "dark"}
                                        label="Visit Patient Site"
                                        url={props.brandType === 'qsub' ? 'https://www.keytruda.com/qlex/' : 'https://www.keytruda.com'}
                                        aria-label="Visit Patient Site"
                                    />{' '}
                                </div>
                                <div>
                                <CTA.TertiaryButton
                                        dataDesignCategory="bottom_nav_vd"
                                        theme={props.brandType !== 'qsub' ? "light" : "dark"}
                                        label="Contact Us"
                                        url="/contact-us/"
                                    />
                                </div>
                            </div>
                        </LogoContainer>
                    </div>

                   {props.brandType !== 'qsub' && <FooterMenu items={items} />}
                </FooterNavigationContainer>
        </>
    );
};

export {default as FooterLegal } from './FooterLegal';